export const createApplicationScreenshot = `
    mutation createApplicationScreenshot($input: CreateApplicationScreenshotInput!) {
        createApplicationScreenshot(input:$input) {
            id
            url
            path
            selector
            viewportWidth
            viewportHeight
            fullPage
            waitForSelector
            delay
            deviceScaleFactor
            hideScrollbars
            status
            screenshotUrl
    }
}`;

export const updateApplicationScreenshot = `
    mutation updateApplicationScreenshot($input: UpdateApplicationScreenshotInput!) {
        updateApplicationScreenshot(input:$input) {
            id
            url
            path
            selector
            viewportWidth
            viewportHeight
            fullPage
            waitForSelector
            delay
            deviceScaleFactor
            hideScrollbars
            status
            screenshotUrl
    }
}`;

export const retakeApplicationScreenshot = `
    mutation retakeApplicationScreenshot($input: RetakeApplicationScreenshotInput!) {
        retakeApplicationScreenshot(input:$input) {
            id
            url
            path
            selector
            viewportWidth
            viewportHeight
            fullPage
            waitForSelector
            delay
            deviceScaleFactor
            hideScrollbars
            status
            screenshotUrl
    }
}`;

export const deleteApplicationScreenshot = `
    mutation deleteApplicationScreenshot($input: DeleteApplicationScreenshotInput!) {
        deleteApplicationScreenshot(input:$input) {
            id
        }

}`;
